import React from 'react';
import PropTypes from 'prop-types';
import { Box } from "~/native-ui/native-base"
import { Button } from "~/native-ui/Button"

class CardActions extends React.Component {
    renderActions() {
        let { actions, } = this.props;

        if (!actions) return null;

        if (actions instanceof Array) {
            actions = actions.map((action, idx) => {
                return <Button key={idx} {...action} />; // eslint-disable-line
            });
        }

        return (
            <Button.ButtonGroup space={2}>
                {actions}
            </Button.ButtonGroup>
        )
    }

    render () {
        const { children, } = this.props
        return (
            <Box>
                { this.renderActions() }
                { children }
            </Box>
        )
    }
}

CardActions.propTypes = {
  children: PropTypes.node,
  actions: PropTypes.any
};

export default CardActions;
export { CardActions };
